<div class="p-30">
    <h3 mat-dialog-title>Dialog with elements</h3>
    <p mat-dialog-content>This dialog showcases the title, close, content and actions elements.</p>
    <div mat-dialog-actions>
        <button mat-button mat-dialog-close (click)="close()" class="border-none fw-semibold ps-30 pe-30 pt-12 pb-12 cursor-pointer">Close</button>
    </div>
</div>